var Shopify = Shopify || {};
// Global variable to track all cart components
let cartComponents = [];

// Product page specific code
let product, currentOptions = {};
let stocksMap = {};

// Try to initialize product info if we're on a product page
try {
  const productElement = document.querySelector('[data-product-id]');
    console.log('tgest2', productElement);
  if (productElement) {
    product = JSON.parse(productElement.textContent);
    console.log('tgest', product);
    const amount_with_comma_separator = '{{amount_with_comma_separator}}';
    const variants = document.querySelectorAll('[data-variant]');
    const optionsSize = parseInt(document.querySelector('[data-options-size]').getAttribute('data-options-size'));
    const quantityInput = document.querySelector('.quantity-input');
    const incrementButton = document.querySelector('.increment-button');
    const decrementButton = document.querySelector('.decrement-button');
    const crossselling = document.querySelectorAll('.crossselling-product');
    const addToCartForm = document.querySelector('form[id="add-to-cart"]');
    const stocks = document.querySelectorAll('input[name="variant-stock"]');

    // Initialize stock map
    stocks.forEach((stock) => {
      const variantId = stock.value;
      const stockValue = parseInt(stock.getAttribute('data-stock'));
      stocksMap[variantId] = stockValue;
    });

    // Add to cart
    if (addToCartForm) {
      addToCartForm.addEventListener('submit', function (event) {
        event.preventDefault();
        const formData = new FormData(addToCartForm);
        const productId = formData.get('id');
        const productQty = formData.get('quantity');

        const items = [
          {
            id: productId,
            quantity: parseInt(productQty, 10),
          },
        ];

        if (crossselling) {
          document.querySelectorAll('.crossselling-product').forEach(function (p) {
            console.log('tgest3', p);
            const checkbox = p.querySelector('input[type="checkbox"]');
            if (checkbox && checkbox.checked) {
              const variantId = checkbox.getAttribute('data-variant-id');
              const crossellingQty = p.querySelector('.quantity-input-crossselling').value;
              items.push({
                id: variantId,
                quantity: parseInt(crossellingQty, 10),
              });
            }
          });
        }

        if (items) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: items }),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log('Add to cart');
              showCartNotification(data, items);
              // Use the new updateAllCartDropdowns function instead of the old updateSmallcart
              updateAllCartDropdowns();
              setTimeout(function () {
                hideCartNotification();
              }, 3000);
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        }
      });
    }

    // Variants
    if (variants) {
      // First init of the variants
      initializeVariants();

      // Get the on click or on change state of the variant
      variants.forEach((variant) => {
        ['click', 'change'].forEach((event) => {
          variant.addEventListener(event, () => handleVariantChange(variant));
        });
      });
    }

    // Crossselling
    if (crossselling) {
      crossselling.forEach(function (p) {
        handleCrosssellingChange(p);
      });
    }

    // Zet de actieve staffel-visual op de rij die bij de huidige quantity hoort
    function syncStaffelActiveState() {
      const qtyInput = document.querySelector('.quantity-input');
      if (!qtyInput) return;
      const quantity = parseInt(qtyInput.value, 10) || 1;
      document.querySelectorAll('[data-volume-quantity]').forEach((staffel) => {
        const staffelQty = parseInt(staffel.getAttribute('data-volume-quantity'), 10);
        const isActive = staffelQty === quantity;
        staffel.classList.toggle('border-[#183B64]', isActive);
        staffel.classList.toggle('bg-[#F8F8F8]', isActive);
        staffel.classList.toggle('border-[#DDD9D9]', !isActive);
        const fillCircle = staffel.querySelector('.fill-circle');
        if (fillCircle) fillCircle.classList.toggle('hidden', !isActive);
      });
    }

    // Staffel-klik wordt via DOMContentLoaded hieronder altijd op document gezet (capture-fase)

    // Na staffel DOM-refresh: opnieuw klik-handler op container zetten (bij variantwissel kan container vervangen zijn) + visuele state syncen
    function onVolumeDiscountsRefreshed() {
      if (typeof ensureStaffelListenerAttached === 'function') ensureStaffelListenerAttached();
      syncStaffelActiveState();
    }
    setTimeout(() => onVolumeDiscountsRefreshed(), 3000);
    document.addEventListener('volume-discounts-refreshed', onVolumeDiscountsRefreshed);

    // Setup quantity controls
    setupQuantityControls();

    // Expose for delivery option script (em-variants.liquid)
    window.currentOptions = currentOptions;
    window.updateCurrentOptions = updateCurrentOptions;
  }
} catch (error) {
  console.error('Error initializing product page:', error);
}

// Staffel-klik: op document in capture-fase, op basis van klikcoördinaten (werkt ook als een overlay de klik onderschept)
function handleStaffelClickByCoordinates(e) {
  var container = document.querySelector('#volume-discount-container');
  if (!container) return;
  var rect = container.getBoundingClientRect();
  var x = e.clientX;
  var y = e.clientY;
  if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) return;

  var rows = container.querySelectorAll('[data-volume-quantity]');
  for (var i = 0; i < rows.length; i++) {
    var r = rows[i].getBoundingClientRect();
    if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) {
      e.preventDefault();
      e.stopPropagation();
      var staffel = rows[i];
      var qtyInput = document.querySelector('.quantity-form .quantity-input') || document.querySelector('.quantity-input');
      if (!qtyInput) return;
      var volume_quantity = staffel.getAttribute('data-volume-quantity');
      qtyInput.value = parseInt(volume_quantity, 10);

      document.querySelectorAll('[data-volume-quantity]').forEach(function(s) {
        s.classList.remove('border-[#183B64]', 'bg-[#F8F8F8]');
        s.classList.add('border-[#DDD9D9]');
        var fc = s.querySelector('.fill-circle');
        if (fc) fc.classList.add('hidden');
      });
      staffel.classList.remove('border-[#DDD9D9]');
      staffel.classList.add('border-[#183B64]', 'bg-[#F8F8F8]');
      var fillCircle = staffel.querySelector('.fill-circle');
      if (fillCircle) fillCircle.classList.remove('hidden');

      if (typeof window.updateCurrentOptions === 'function' && window.currentOptions) {
        window.updateCurrentOptions(window.currentOptions);
      }
      return;
    }
  }
}

function ensureStaffelListenerAttached() {
  // Alleen nog voor syncStaffelActiveState bij refresh; klikken worden op document afgehandeld
}

window.ensureStaffelListenerAttached = ensureStaffelListenerAttached;

// Main cart component initialization
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', handleStaffelClickByCoordinates, true);
  ensureStaffelListenerAttached();

  // Setup the swatch variant behavior for image swatches if on product page
  const variantSwatches = document.querySelectorAll('.variant-swatch');
  
  variantSwatches.forEach(swatch => {
    // Handle swatch selection
    swatch.addEventListener('click', function() {
      const input = this.querySelector('input');
      if (input) {
        input.checked = true;
        
        // Trigger the change event manually
        const event = new Event('change', { bubbles: true });
        input.dispatchEvent(event);
      }
    });
  });

  // Initialize all cart components
  initializeCartComponents();
});

function updateCrosssellingForVariant(variantId) {
  const crosssellingContainer = document.getElementById('crossselling-items');
  
  if (!crosssellingContainer) return;
  
  // Check if this variant has specific crossselling items, otherwise use product-level
  const variantCrossselling = window.variantCrossselling?.[variantId];
  const crosssellingData = (variantCrossselling && variantCrossselling.length > 0) 
    ? variantCrossselling 
    : window.productLevelCrossselling;
  
  // If no crossselling data at all (neither variant nor product level), hide the section
  if (!crosssellingData || crosssellingData.length === 0) {
    const crosssellingSection = document.getElementById('crossselling-container');
    if (crosssellingSection) {
      crosssellingSection.style.display = 'none';
    }
    return;
  }
  
  // Show the crossselling section
  const crosssellingSection = document.getElementById('crossselling-container');
  if (crosssellingSection) {
    crosssellingSection.style.display = 'block';
  }
  
  // Clear existing items (including placeholder text)
  crosssellingContainer.innerHTML = '';
  
  // Render new crossselling items
  crosssellingData.forEach((item, index) => {
    const displayImage = item.featured_image?.src || item.image || '';
    const itemIndex = index + 1;
    const settings = window.crosssellingSettings || {};
    
    // Handle product title - variant metafields might have it nested differently
    const productTitle = item.product_title || item.product?.title || '';
    const variantTitle = item.title || item.variant_title || '';
    const fullTitle = variantTitle && !variantTitle.includes('Default Title') 
      ? `${productTitle} - ${variantTitle}` 
      : productTitle;
    
    const crosssellHTML = `
      <div
        class="flex items-start gap-4${index < crosssellingData.length - 1 ? ' mb-1' : ''} crossselling-product bg-white py-1.5 rounded-md pl-3"
        id="crossselling-${itemIndex}"
        data-crosssell-index="${itemIndex}"
      >
        <label
          for="check-${itemIndex}"
          class="flex-0 whitespace-nowrap bg-[#DDD9D9] peer-checked:bg-accent cursor-pointer relative w-9 h-4 rounded-full block mt-[20px]"
          style="flex-shrink: 0;"
        >
          <input
            type="checkbox"
            id="check-${itemIndex}"
            class="sr-only peer"
            data-variant-id="${item.id}"
          >
          <input
            type="quantity"
            value="1"
            class="hidden quantity-input-crossselling"
          >
          <span class="w-full h-full peer-checked:bg-highlight_light absolute rounded-full duration-200 transition-all"></span>
          <span class="w-5 h-5 bg-white absolute shadow-md rounded-full left-[-3px] top-[-2px] peer-checked:left-[19px] transition-all duration-200"></span>
        </label>
        
        <div class="flex justify-between gap-4 px-3 py-1 md:w-[92.5%] md:pr-7">
          <div class="flex items-start md:items-center md:w-[65%]">
            ${displayImage ? `
              <img
                src="${displayImage}"
                alt="${fullTitle}"
                width="500"
                height="500"
                class="w-12 h-12 object-cover rounded-sm mr-4"
              >
            ` : ''}
            
            <div class="flex flex-col md:flex-row md:items-center w-full">
              <span class="font-bold text-h6 mb-1 md:mb-0 md:text-h5 md:max-w-[50vw] md:hidden">
                ${fullTitle}
              </span>
              <span class="font-bold text-h5 max-w-[50vw] hidden md:block">
                ${productTitle}${variantTitle && !variantTitle.includes('Default Title') ? ` - ${variantTitle.length > 50 ? variantTitle.substring(0, 50) + '...' : variantTitle}` : ''}
              </span>
              <div class="flex items-center gap-1 md:hidden">
                <div class="flex items-center gap-1">
                  <div
                    class="text-sm flex gap-2 items-center text-highlight_dark font-bold"
                    data-product-price="${item.price}"
                    data-excl-price="${item.price}"
                  >
                    <strong>${formatMoney(item.price)}</strong>
                  </div>
                  <span class="text-body text-black font-medium">per stuk</span>
                </div>
              </div>
            </div>
          </div>
          
          <div class="flex justify-between items-center">
            <form class="${settings.show_quantity_selector ? '' : 'hidden'}">
              <div class="relative flex items-center">
                <button
                  type="button"
                  class="decrement-crosssell bg-[#2C3440] border-[#2C3440] rounded-l-sm p-3 !h-10"
                  data-target="quantity-input-${itemIndex}"
                >
                  <img src="${window.Shopify?.routes?.root || '/'}assets/em-minus.svg" alt="Decrease" width="14" height="9">
                </button>
                <input
                  type="text"
                  id="quantity-input-${itemIndex}"
                  class="crossselling-quantity-input bg-white border-x-0 border-[#2C3440] !h-10 text-center text-[#2C3440] text-sm w-12 py-2.5"
                  value="1"
                  required
                >
                <button
                  type="button"
                  class="increment-crosssell bg-[#2C3440] border-[#2C3440] rounded-r-sm p-3 !h-10"
                  data-target="quantity-input-${itemIndex}"
                >
                  <img src="${window.Shopify?.routes?.root || '/'}assets/em-plus.svg" alt="Increase" width="14" height="14">
                </button>
              </div>
            </form>
            
            <div class="flex gap-2 items-center">
              <div class="flex items-center gap-1 hidden md:block">
                <div class="flex items-center gap-1">
                  <div
                    class="text-sm flex gap-2 items-center text-highlight_dark font-bold"
                    data-product-price="${item.price}"
                    data-excl-price="${item.price}"
                  >
                    <strong>${formatMoney(item.price)}</strong>
                  </div>
                  <span class="text-body text-black font-medium">per stuk</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    
    crosssellingContainer.insertAdjacentHTML('beforeend', crosssellHTML);
  });
  
  // Re-initialize crossselling functionality for the new items
  const newCrosssellingProducts = crosssellingContainer.querySelectorAll('.crossselling-product');
  newCrosssellingProducts.forEach(p => {
    handleCrosssellingChange(p);
  });
  
  // Setup quantity controls for new items
  setupCrosssellingQuantityControls();
}

// Helper function to format money
function formatMoney(cents) {
  const amount = cents / 100;
  return amount.toFixed(2).replace('.', ',');
}

// Setup quantity controls for crossselling items
function setupCrosssellingQuantityControls() {
  const incrementButtons = document.querySelectorAll('.increment-crosssell');
  const decrementButtons = document.querySelectorAll('.decrement-crosssell');
  
  incrementButtons.forEach(button => {
    button.addEventListener('click', function() {
      const targetId = this.getAttribute('data-target');
      const input = document.getElementById(targetId);
      if (input) {
        const currentValue = parseInt(input.value) || 1;
        input.value = currentValue + 1;
        
        // Trigger price update
        const checkbox = input.closest('.crossselling-product').querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
          updatePriceWithCrossselling();
        }
      }
    });
  });
  
  decrementButtons.forEach(button => {
    button.addEventListener('click', function() {
      const targetId = this.getAttribute('data-target');
      const input = document.getElementById(targetId);
      if (input) {
        const currentValue = parseInt(input.value) || 1;
        if (currentValue > 1) {
          input.value = currentValue - 1;
          
          // Trigger price update
          const checkbox = input.closest('.crossselling-product').querySelector('input[type="checkbox"]');
          if (checkbox && checkbox.checked) {
            updatePriceWithCrossselling();
          }
        }
      }
    });
  });
  
  // Handle direct input changes
  const quantityInputs = document.querySelectorAll('.crossselling-quantity-input');
  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      const value = parseInt(this.value) || 1;
      this.value = Math.max(1, value);
      
      const checkbox = this.closest('.crossselling-product').querySelector('input[type="checkbox"]');
      if (checkbox && checkbox.checked) {
        updatePriceWithCrossselling();
      }
    });
  });
}

// Function to initialize all cart components
function initializeCartComponents() {
  // Find all cart components on the page
  const allCartComponents = document.querySelectorAll('[data-component-id^="cart-component-"]');
  
  if (allCartComponents.length === 0) {
    console.log('No cart components found on page');
    return;
  }
  
  // Clear the components array in case this is called multiple times
  cartComponents = [];
  
  allCartComponents.forEach(component => {
    const componentId = component.getAttribute('data-component-id');
    const index = componentId.split('-').pop();
    const toggleBtn = document.getElementById(`cartToggle-${index}`);
    const dropdown = document.getElementById(`cartDropdown-${index}`);
    const closeCart = document.getElementById(`close-cart-${index}`);
    const accountDropdown = document.querySelector('#accountDropdown');
    
    if (toggleBtn && dropdown) {
      // Store component info for future updates
      cartComponents.push({
        component: component,
        dropdown: dropdown,
        index: index
      });
      
      toggleBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log(`Cart ${componentId} toggle clicked`);
        
        // Update ALL cart dropdowns before showing this one
        updateAllCartDropdowns().then(() => {
          // dropdown.classList.toggle('hidden');
          // dropdown.classList.toggle('show');
          
          // if (accountDropdown) {
          //   accountDropdown.classList.add('opacity-0', 'pointer-events-none');
          //   accountDropdown.classList.remove('opacity-100');
          // }
        });
      });
      
      if (closeCart) {
        closeCart.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          dropdown.classList.remove('show');
          dropdown.classList.add('hidden');
        });
      }
      
      // Close dropdown when clicking outside this component
      document.addEventListener('click', function(e) {
        if (!component.contains(e.target)) {
          dropdown.classList.remove('show');
          dropdown.classList.add('hidden');
        }
      });
      
      console.log(`Cart ${componentId} initialized`);
    }
  });
  
  // Initial update of all carts
  updateAllCartDropdowns();
}

// Function to update all cart dropdowns
async function updateAllCartDropdowns() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error('Failed to fetch cart');
    }
    
    const cart = await response.json();

    console.log('cart', cart);
    
    // Update all cart counts across the page
    updateAllCartCounts(cart.item_count);
    
    // Update all cart dropdowns
    cartComponents.forEach(cartComponent => {
      updateCartHTML(cartComponent.dropdown, cart);
    });
    
    return cart;
  } catch (error) {
    console.error('Error updating cart contents:', error);
  }
}

// Function to update all cart counts
function updateAllCartCounts(count) {
  const cartCounts = document.querySelectorAll('.cart-count p');
  cartCounts.forEach(countElement => {
    countElement.textContent = count;
  });
}

// Function to update the cart dropdown HTML with latest cart data
function updateCartHTML(dropdown, cart) {
  // Find the cart items container
  const cartItemsContainer = dropdown.querySelector('.cart-items');
  
  if (!cartItemsContainer) return;
  
  // Clear existing content
  cartItemsContainer.innerHTML = '';
  
  if (cart.item_count === 0) {
    // Display empty cart message if no items
    const cartFilled = dropdown.querySelector('.filled-cart');
    const cartItems = dropdown.querySelector('.cart-items');
    const cartTotals = dropdown.querySelector('.cart-totals');
    const cartActions = dropdown.querySelector('.cart-actions');
    
    if (cartFilled) cartFilled.style.display = 'none';
    if (cartItems) cartItems.style.display = 'none';
    if (cartTotals) cartTotals.style.display = 'none';
    if (cartActions) cartActions.style.display = 'none';
    
    const emptyCartDiv = dropdown.querySelector('.empty-cart');
    if (!emptyCartDiv) {
      const emptyCart = document.createElement('div');
      emptyCart.className = 'empty-cart text-center py-8';
      emptyCart.innerHTML = `
        <p class="text-lg mb-4">Je winkelwagen is leeg</p>
        <a href="/collections/all" class="inline-block bg-green-500 text-white font-bold py-3 px-6 rounded">
          Bekijk onze producten
        </a>
      `;
      cartItemsContainer.parentNode.appendChild(emptyCart);
    } else {
      emptyCartDiv.style.display = 'block';
    }
    return;
  }
  
  // Show cart containers and hide empty cart message
  const emptyCartDiv = dropdown.querySelector('.empty-cart');
  if (emptyCartDiv) {
    emptyCartDiv.style.display = 'none';
  }
  
  const cartFilled = dropdown.querySelector('.filled-cart');
  const cartItems = dropdown.querySelector('.cart-items');
  const cartTotals = dropdown.querySelector('.cart-totals');
  const cartActions = dropdown.querySelector('.cart-actions');
  
  if (cartFilled) cartFilled.style.display = 'block';
  if (cartItems) cartItems.style.display = 'block';
  if (cartTotals) cartTotals.style.display = 'block';
  if (cartActions) cartActions.style.display = 'block';
  
  // Add each cart item to the container
  cart.items.forEach((item, index) => {
    const isLastItem = index === cart.items.length - 1;
    const cartItem = document.createElement('div');
    cartItem.className = `cart-item py-4 flex items-end gap-4 ${!isLastItem ? 'border-b border-gray-200' : ''}`;
    
    // Format the price with currency
    const price = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    }).format(item.final_price / 100);
    
    cartItem.innerHTML = `
      <a href="${item.url}" class="flex-shrink-0 w-20">
        <img src="${item.image || '/assets/no-image.jpg'}" alt="${item.title}" class="w-full h-auto">
      </a>
      <div class="flex flex-col">
        <a href="${item.url}" class="text-base font-bold leading-tight mb-1 cart-item-title" style="white-space: wrap">${item.product_title}</a>
        ${item.variant_title && item.variant_title !== 'Default Title' ? 
          `<p class="text-sm truncate" style="white-space: wrap">${item.variant_title}</p>` : ''}
        <p class="text-sm">Aantal: ${item.quantity}</p>
      </div>
      <div class="flex-shrink-0 text-right ml-auto">
        <p data-excl-price="${item.final_price}">${price}</p>
      </div>
    `;
    
    cartItemsContainer.appendChild(cartItem); 
  });
  
  // Update the totals
  const freeTxt = cart.total_price >= 15000 ? 'Gratis' : '€6,61';
  const totalsEl = dropdown.querySelector('.cart-totals');
  if (totalsEl) {
    const shippingEl = totalsEl.querySelector('#cart-shipping-price p:last-child');
    if (shippingEl) {
      shippingEl.textContent = freeTxt;
      if (cart.total_price >= 15000) {
        shippingEl.removeAttribute('data-excl-price');
      } else {
        shippingEl.setAttribute('data-excl-price', 661);
      }
      shippingEl.className = cart.total_price >= 15000 ? 
        'text-body font-bold text-green-500' : 'text-body font-bold';
    }

    const totalVat = totalsEl.querySelector('#cart-vat-price');
    if (totalVat) {
      const totalPriceShipping = cart.total_price >= 15000 ? cart.total_price : cart.total_price + 661;
      const totalPriceIncl = cart.total_price >= 15000 ? cart.total_price * 1.21 : (cart.total_price + 661) * 1.21; 
      const totalVatPrice = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
      }).format((totalPriceIncl - totalPriceShipping) / 100);
      totalVat.textContent = totalVatPrice;
    }
    
    const totalEl = totalsEl.querySelector('#cart-total-price');
    if (totalEl) {
      // Format the total price with currency
      const totalPrice = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
      }).format(cart.total_price / 100);
      const totalPriceWithShipping = cart.total_price + 661;
      const totalPriceWithShippingFormatted = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
      }).format(totalPriceWithShipping / 100);
      totalEl.textContent = cart.total_price >= 15000 ? totalPrice : totalPriceWithShippingFormatted;
      totalEl.setAttribute('data-excl-price', cart.total_price >= 15000 ? cart.total_price : totalPriceWithShipping);
    }
  }

  // Prijzen hierboven zijn excl. BTW gezet; incl/excl-weergave van de switcher opnieuw toepassen
  if (typeof window.reapplyVatPrices === 'function') {
    window.reapplyVatPrices();
  }
}

// Cart notification functions
function showCartNotification(shoppingcart, added) {
  const cart_notification = document.querySelectorAll('.custom-cart-notification');
  const products = shoppingcart.items;
  const added_products = added;
  const notification_products = [];

  cart_notification.forEach((cartNotification) => {
    if (cartNotification.classList.contains('hidden')) {
      cartNotification.classList.remove('hidden');
    }
    // Clear any existing content
    cartNotification.innerHTML = '';
  });

  if ('items' in shoppingcart) {
    products.forEach((product) => {
      var product_id = product.id;
      var title = product.product_title;

      added_products.forEach((item) => {
        var added_id = item.id;
        var added_quantity = item.quantity;
        if (product_id == added_id) {
          notification_products.push({
            quantity: added_quantity,
            title: title,
          });
        }
      });
    });

    if (notification_products.length > 0) {
      var div = document.createElement('div');
      div.className = 'bg-white shadow-lg rounded-md py-6 px-6';
      var h3 = document.createElement('h3');
      h3.className = 'mb-4 text-lg leading-normal font-bold text-black';
      h3.textContent = 'Toegevoegd!';
      var ul = document.createElement('ul');
      notification_products.forEach((item) => {
        var li = document.createElement('li');
        li.className = 'text-sm mb-2 text-highlight_dark';
        li.textContent = item.quantity + ' x ' + item.title;
        ul.appendChild(li);
      });
      var a = document.createElement('a');
      a.className = 'block bg-green-500 text-white font-bold py-3 px-6 rounded cursor-pointer text-center mt-6';
      a.textContent = 'Ga naar winkelwagen';
      a.href = '/cart';
      div.appendChild(h3);
      div.appendChild(ul);
      div.appendChild(a);
      cart_notification.forEach((cartNotification) => {
        cartNotification.appendChild(div.cloneNode(true));
      });
    }
  } else {
    var div = document.createElement('div');
    div.className = 'bg-mediocre rounded-[3px] py-6 px-6';
    var h3 = document.createElement('h3');
    h3.className = 'mb-4 text-lg leading-normal font-bold text-black';
    h3.textContent = 'Niet toegevoegd!';
    var p = document.createElement('p');
    p.textContent = shoppingcart.message;
    var a = document.createElement('a');
    a.className = 'block bg-highlight_light text-highlight_dark cursor-pointer font-bold text-center py-2 rounded-[3px] mt-6';
    a.textContent = 'Ga naar winkelwagen';
    a.href = '/cart';
    div.appendChild(h3);
    div.appendChild(p);
    div.appendChild(a);
    cart_notification.forEach((cartNotification) => {
      cartNotification.appendChild(div.cloneNode(true));
    });
  }
  
  // Update all cart dropdowns too
  updateAllCartDropdowns();
}

function hideCartNotification() {
  const cart_notification = document.querySelectorAll('.custom-cart-notification');
  cart_notification.forEach((cartNotification) => {
    cartNotification.classList.add('hidden');
    cartNotification.innerHTML = '';
  });
}

// Product page specific functions
// Lees een eventueel ?variant=<id> uit de URL (gezet vanaf de productkaart-dropdown).
function getVariantIdFromUrl() {
  try {
    var v = new URLSearchParams(window.location.search).get('variant');
    return v ? parseInt(v, 10) : null;
  } catch (e) {
    return null;
  }
}

// Selecteer een specifieke optiewaarde in de UI (zowel SELECT als INPUT/swatch).
function selectOptionValue(optionName, value) {
  var el = document.querySelector(`[name="${optionName}"]`);
  if (!el || value == null) return;

  if (el.tagName == 'SELECT') {
    Array.from(el.options).forEach((o) => {
      if (o.getAttribute('data-value') === value) o.selected = true;
    });
    currentOptions[optionName] = value;
  } else {
    var allInputs = document.querySelectorAll(`[name="${optionName}"]`);
    allInputs.forEach((item) => item.parentElement.classList.remove('variant-active'));
    var input = document.querySelector(`[name="${optionName}"][data-value="${value}"]`);
    if (input) {
      input.parentElement.classList.add('variant-active');
      input.checked = true;
      currentOptions[optionName] = value;
    }
  }
}

function initializeVariants() {
  if (!product) return;

  const optionNames = ['option1', 'option2', 'option3'];

  // Als de URL een geldige ?variant= bevat: die variant voorselecteren.
  var urlVariantId = getVariantIdFromUrl();
  var targetVariant = urlVariantId
    ? product.variants.find((v) => v.id === urlVariantId)
    : null;

  if (targetVariant) {
    optionNames.forEach((optionName) => {
      if (document.querySelector(`[name="${optionName}"]`)) {
        selectOptionValue(optionName, targetVariant[optionName]);
      }
    });
  } else {
    // Standaardgedrag: selecteer de eerste opties.
    optionNames.forEach((optionName) => {
      var option = document.querySelector(`[name="${optionName}"]`);
      if (option) {
        if (option.tagName == 'INPUT') {
          var optionValue = document.querySelector(`[name="${optionName}"]`).getAttribute('data-value');
          var parent = option.parentElement;
          if (!parent.classList.contains('variant-active')) {
            parent.classList.add('variant-active');

            // Special handling for image swatches
            if (parent.classList.contains('variant-swatch')) {
              parent.classList.add('variant-active');
            }

            currentOptions[optionName] = optionValue;
          }
        }
        if (option.tagName == 'SELECT') {
          var optionValue = option.options[1].getAttribute('data-value');
          option.options[1].selected = true;
          currentOptions[optionName] = optionValue;
        }
      }
    });
  }

  // Update the current stock and price
  if (currentOptions) {
    updateCurrentOptions(currentOptions);
  }

  // Bij voorselectie via URL ook de productafbeelding meenemen.
  if (targetVariant) {
    try { updateProductImages(); } catch (e) {}
  }
}

function handleVariantChange(variant) {
  console.log('handleVariantChange', variant);
  // First get the option name
  const optionName = variant.getAttribute('data-name');

  // Second get the option value based on the type
  if (variant.tagName == 'SELECT') {
    const selectedOption = variant.options[variant.selectedIndex];
    var optionValue = selectedOption.getAttribute('data-value');
  } else {
    var optionValue = variant.getAttribute('data-value');
  }

  // Check if optionValue is not null
  if (optionValue !== null) {
    // Create object with the values
    currentOptions[optionName] = optionValue;

    // Create active state on the click elements (only on inputs)
    if (variant.tagName == 'INPUT') {
      var allInputs = document.querySelectorAll(`[name="${optionName}"]`);
      var input = document.querySelector(`[name="${optionName}"][data-value="${currentOptions[optionName]}"]`);
      var label = input.parentElement;

      // Remove all class actives from the currently clicked labels
      allInputs.forEach((item) => {
        var parentItem = item.parentElement;
        parentItem.classList.remove('variant-active');
      });

      // Add class active to the clicked label
      label.classList.add('variant-active');
    }

    // Update the current stock and price
    if (currentOptions) {
      updateCurrentOptions(currentOptions);
    }
    
    // Update the product images if applicable
    updateProductImages();
  }
}

function updateProductImages() {
  if (!product) return;
  
  // Find the currently selected variant
  var option1 = currentOptions['option1'] || 'Default Title';
  var option2 = currentOptions['option2'] || '';
  var option3 = currentOptions['option3'] || '';

  let currentVariant;
  const optionsSize = parseInt(document.querySelector('[data-options-size]')?.getAttribute('data-options-size')) || 1;
  
  // Find the current variant based on the selected options
  switch (optionsSize) {
    case 3:
      currentVariant = product.variants.find(
        (variant) => variant.option1 === option1 && variant.option2 === option2 && variant.option3 === option3
      );
      break;
    case 2:
      currentVariant = product.variants.find(
        (variant) => variant.option1 === option1 && variant.option2 === option2
      );
      break;
    case 1:
      currentVariant = product.variants.find(
        (variant) => variant.option1 === option1
      );
      break;
  }

  // If the variant has a featured image, update the main product image
  if (currentVariant && currentVariant.featured_image) {
    // Try to update the main product image in Swiper if available
    const mainImageContainer = document.querySelector('.mySwiper2 .swiper-slide-active img');
    if (mainImageContainer) {
      mainImageContainer.src = currentVariant.featured_image.src;
      
      // Also try to find and click the corresponding thumbnail if present
      const thumbnails = document.querySelectorAll('.mySwiper .swiper-slide img');
      thumbnails.forEach(thumbnail => {
        if (thumbnail.src.includes(currentVariant.featured_image.src.split('?')[0])) {
          thumbnail.closest('.swiper-slide').click();
        }
      });
    }
  }
}

function handleCrosssellingChange(p) {
  const incrementButton = p.querySelector('.increment-crosssell, #increment-button');
  const decrementButton = p.querySelector('.decrement-crosssell, #decrement-button');
  const quantityInput = p.querySelector('.crossselling-quantity-input, .quantity-input-crossselling');
  const productPriceElement = p.querySelector('[data-product-price]');
  const checkbox = p.querySelector('input[type="checkbox"]');
  
  if (!productPriceElement) return;
  
  const basePrice = parseFloat(productPriceElement.getAttribute('data-product-price')) / 100;

  var quantity = parseInt(quantityInput?.value) || 1;
  var totalPrice = basePrice;

  function updateQuantityAndPrice() {
    if (quantityInput) {
      quantityInput.value = quantity;
    }
    totalPrice = basePrice * quantity;
    productPriceElement.innerHTML = `${totalPrice.toFixed(2).replace('.', ',')}`;
    if (decrementButton) {
      decrementButton.disabled = quantity === 1;
    }
    if (checkbox && checkbox.checked) {
      updatePriceWithCrossselling();
    }
  }

  updateQuantityAndPrice();

  if (incrementButton && !incrementButton.hasAttribute('data-listener-attached')) {
    incrementButton.setAttribute('data-listener-attached', 'true');
    incrementButton.addEventListener('click', () => {
      quantity += 1;
      updateQuantityAndPrice();
    });
  }

  if (decrementButton && !decrementButton.hasAttribute('data-listener-attached')) {
    decrementButton.setAttribute('data-listener-attached', 'true');
    decrementButton.addEventListener('click', () => {
      if (quantity > 1) {
        quantity -= 1;
        updateQuantityAndPrice();
      }
    });
  }

  if (checkbox && !checkbox.hasAttribute('data-listener-attached')) {
    checkbox.setAttribute('data-listener-attached', 'true');
    checkbox.addEventListener('change', () => {
      updatePriceWithCrossselling();
    });
  }
}

function updateCurrentOptions(currentOptions) {
  if (!product) return;
  
  var option1 = currentOptions['option1'] || 'Default Title';
  var option2 = currentOptions['option2'] || '';
  var option3 = currentOptions['option3'] || '';
  
  const optionsSize = parseInt(document.querySelector('[data-options-size]')?.getAttribute('data-options-size')) || 1;

  // Check how many variants are available
  switch (optionsSize) {
    case 3:
      var currentOption = product.variants.filter(
        (variant) => variant.option1 === option1 && variant.option2 === option2 && variant.option3 == option3
      );
      break;
    case 2:
      var currentOption = product.variants.filter(
        (variant) => variant.option1 === option1 && variant.option2 === option2
      );
      break;
    case 1:
      var currentOption = product.variants.filter((variant) => variant.option1 === option1);
      break;
  }

  if (currentOption && currentOption.length > 0) {
    var id = currentOption[0].id;
    var sku = currentOption[0].sku;
    var price = currentOption[0].price;

    if (document.getElementById('discount-percentage-unit')) {
      const discountPercentageUnit = document.getElementById('discount-percentage-unit').textContent;
      price = price * parseFloat(discountPercentageUnit);
    }

    var compare_at_price = currentOption[0].compare_at_price;
    var stock = stocksMap[id] || 0;
    var barcode = currentOption[0].barcode;
    var available = currentOption[0].available;

    updatePriceWithStock(price, compare_at_price, stock, id, available, sku);
    updateBarcode(barcode);
    
    // ADD THIS LINE - Update crossselling for the selected variant
    updateCrosssellingForVariant(id);
  }
}

// Shipping price calculation: spoedverzending is per item (niet per regel), dus × quantity
// When spoedAlreadyInBase is true, staffel is already applied to (product+spoed), so don't add again
function calculateTotalWithShipping(basePrice, quantity, spoedAlreadyInBase) {
  if (spoedAlreadyInBase) return basePrice;
  const qty = Math.max(1, parseInt(quantity, 10) || 1);
  const shippingPrice = parseFloat(localStorage.getItem('selectedDeliveryPrice')) || 0;
  const shippingPriceCents = Math.round(shippingPrice * 100);
  return basePrice + (shippingPriceCents * qty);
}

function updatePriceWithStock(price, compare_at_price, stock, id, available, sku) {
  const volumeDiscountContainer = document.querySelector('#volume-discount-container');
  const quantityInput = document.querySelector('.quantity-input');
  const crossselling = document.querySelectorAll('.crossselling-product');
  const currentPrice = document.querySelector('.current-price');
  const currentComparePrice = document.getElementById('total-compare-price');
  const currentSku = document.querySelector('#product-sku');
  
  if (!currentPrice) return;

  // Zorg dat de spoedtoeslag voor de HUIDIGE variant in localStorage staat vóór we 'm uitlezen,
  // anders rekent de eerste render met de toeslag van de vorige maat (prijs-flikker).
  if (typeof window.syncSpoedPriceToStorage === 'function') {
    window.syncSpoedPriceToStorage();
  }
  const quantity = parseInt(quantityInput?.value || 1);
  const shippingPriceCents = Math.round((parseFloat(localStorage.getItem('selectedDeliveryPrice')) || 0) * 100);
  // Staffel: totaal in één keer afronden (zoals de app), anders per-stuk afronding geeft verschil
  let productTotalCents = price * quantity;
  let productCompareTotalCents = (compare_at_price || 0) * quantity;
  if (typeof window.getStaffelDiscountedTotalCents === 'function') {
    if (shippingPriceCents > 0) {
      productTotalCents = window.getStaffelDiscountedTotalCents(quantity, price + shippingPriceCents);
      if (compare_at_price && compare_at_price > 0) {
        productCompareTotalCents = window.getStaffelDiscountedTotalCents(quantity, compare_at_price + shippingPriceCents);
      }
    } else {
      productTotalCents = window.getStaffelDiscountedTotalCents(quantity, price);
      if (compare_at_price && compare_at_price > 0) {
        productCompareTotalCents = window.getStaffelDiscountedTotalCents(quantity, compare_at_price);
      }
    }
  }
  var totalPrice = productTotalCents;
  var totalComparePrice = productCompareTotalCents;

  // if (document.getElementById('discount-percentage-unit')) {
  //   const discountPercentageUnit = document.getElementById('discount-percentage-unit').textContent;
  //   totalPrice = totalPrice * parseFloat(discountPercentageUnit);
  //   totalComparePrice = totalComparePrice * parseFloat(discountPercentageUnit);
  // }

  // Add crossselling prices
  if (crossselling) {
    crossselling.forEach(function (p) {
      const checkbox = p.querySelector('input[type="checkbox"]');
      const crosssellingQuantityInput = p.querySelector('.quantity-input-crossselling');

      if (checkbox && checkbox.checked && crosssellingQuantityInput) {
        const crosssellingQuantity = parseInt(crosssellingQuantityInput.value || 1);
        const crosssellingPrice = parseFloat(
          p.querySelector('[data-product-price]').getAttribute('data-product-price')
        );
        totalPrice += crosssellingPrice * crosssellingQuantity;
        totalComparePrice += crosssellingPrice * crosssellingQuantity;
      }
    });
  }
  
  // ADD SHIPPING PRICE HERE (before VAT) – bij spoed + staffel al in totalPrice, anders per stuk toevoegen
  setTimeout(() => {
    const spoedAlreadyInBase = shippingPriceCents > 0 && typeof window.getStaffelDiscountedTotalCents === 'function';
    totalPrice = calculateTotalWithShipping(totalPrice, quantity, spoedAlreadyInBase);
    totalComparePrice = calculateTotalWithShipping(totalComparePrice, quantity, spoedAlreadyInBase);

    // Excl.-totalen bewaren zodat de BTW-toggle (vat-switcher) de totaalprijs correct kan wisselen
    const totalPriceExcl = totalPrice;
    const totalComparePriceExcl = totalComparePrice;

    // 2. VAT
    if (sessionStorage.getItem('pricesIncludeVat') === 'true') {
      totalPrice *= 1.21;
      totalComparePrice *= 1.21;
    }

    // 3. Format everything
    const prettyPrice       = Shopify.formatMoney(totalPrice, '{{amount_with_comma_separator}}');
    const prettyFullPrice   = Shopify.formatMoney(totalPrice / 0.85, '{{amount_with_comma_separator}}');
    let prettyComparePrice = Shopify.formatMoney(totalComparePrice, '{{amount_with_comma_separator}}');

    // 4. Update main price (data-excl-price altijd excl. voor vat-switcher)
    if (currentPrice) {
      currentPrice.setAttribute('data-original-base-price', price);
      currentPrice.setAttribute('data-solo-price', price);
      currentPrice.setAttribute('data-unit-price', price);
      currentPrice.setAttribute('data-original-price', (price / 100).toString());
      currentPrice.setAttribute('data-price', totalPrice);
      currentPrice.setAttribute('data-stock', stock);
      currentPrice.setAttribute('data-excl-price', totalPriceExcl);
      currentPrice.innerHTML = `€${prettyPrice}`;

      if (document.getElementById('real-price')) {
        document.getElementById('real-price').innerHTML = `€${prettyFullPrice}`;
        document.getElementById('real-price').setAttribute('data-excl-price', totalPrice / 0.85);
        document.getElementById('real-price').setAttribute('data-real-price', totalPrice / 0.85);
      }
    }

    // 5. Update compare-at price (only once!)
    if (currentComparePrice) {
      // If there's a collection discount and no compare_at_price, use original price
      let comparePriceToUse = compare_at_price;
      if (!compare_at_price || compare_at_price === 0) {
        // Check if there's a collection discount (discount-percentage-unit exists)
        const discountPercentageUnit = document.getElementById('discount-percentage-unit');
        if (discountPercentageUnit) {
          // Use the original price (before discount) as compare price
          const originalPrice = price / parseFloat(discountPercentageUnit.textContent);
          comparePriceToUse = originalPrice * quantity;
          // Recalculate compare price with shipping and VAT (spoed per stuk)
          let recalcComparePrice = calculateTotalWithShipping(comparePriceToUse, quantity);
          if (sessionStorage.getItem('pricesIncludeVat') === 'true') {
            recalcComparePrice *= 1.21;
          }
          prettyComparePrice = Shopify.formatMoney(recalcComparePrice, '{{amount_with_comma_separator}}');
        }
      }
      
      if (comparePriceToUse && comparePriceToUse > 0) {
        currentComparePrice.setAttribute('data-compare-price', comparePriceToUse);
        currentComparePrice.setAttribute('data-unit-compare-price', compare_at_price || 0);
        currentComparePrice.setAttribute('data-excl-price', totalComparePriceExcl);
        currentComparePrice.innerHTML = `€${prettyComparePrice}`;
        currentComparePrice.style.display = '';
      } else {
        // Geen oude prijs voor deze variant: verberg element en zet compare op 0
        // Zodat refreshVolumeDiscounts de juiste (lege) oude prijzen in de staffel toont
        currentComparePrice.setAttribute('data-unit-compare-price', '0');
        currentComparePrice.setAttribute('data-compare-price', '0');
        currentComparePrice.style.display = 'none';
      }
    }

    // Refresh staffelkortingen so per-stuk prices match current variant
    if (typeof window.refreshVolumeDiscounts === 'function') {
      window.refreshVolumeDiscounts();
    }
    // Spoedverzending-button prijs (incl. staffel) bijwerken
    if (typeof window.updateSpoedPrice === 'function') {
      window.updateSpoedPrice();
    }
  }, 100); // ← timeout stays exactly as you need it

  // SKU can stay outside — it doesn't depend on the formatted prices
  if (currentSku) {
    currentSku.innerHTML = `sku: ${sku}`;
  }

  // Update for the stock
  const addToCartBtn = document.querySelector('[data-add-to-cart-button]');
  
  if (!addToCartBtn) return;

  // Logic for handling out of stock condition
  // If stock is insufficient AND "Continue selling when out of stock" is disabled, show out of stock button
  if ((stock <= 0 || stock < quantity) && !available) {
    // Disable the button and change its appearance for out of stock
    addToCartBtn.disabled = true;
    addToCartBtn.classList.remove('bg-success', 'text-white', 'hover:opacity-85', 'cursor-pointer');
    addToCartBtn.classList.add('bg-gray-400', 'text-white', 'cursor-not-allowed');
    addToCartBtn.textContent = 'Uitverkocht';
  } else {
    // Enable the button and restore its appearance for in stock
    addToCartBtn.disabled = false;
    addToCartBtn.classList.remove('bg-gray-400', 'text-white', 'cursor-not-allowed');
    addToCartBtn.classList.add('bg-success', 'text-white', 'hover:opacity-85', 'cursor-pointer');
    addToCartBtn.innerHTML = '<span class="hidden md:block">Toevoegen aan winkelwagen</span><span class="block md:hidden">Toevoegen</span>';
  }

  // Update the variant ID for the add to cart button
  var variantId = document.querySelector(`input[name="id"]`);
  if (variantId) {
    variantId.value = id;
  }

  // Update the quantity for the add to cart button
  var quantityField = document.querySelector(`input[name="quantity"]`);
  if (quantityField) {
    quantityField.value = quantity;
  }
}

function updatePriceWithCrossselling() {
  const currentPrice = document.querySelector('.current-price');
  const quantityInput = document.querySelector('.quantity-input');
  const crossselling = document.querySelectorAll('.crossselling-product');
  
  if (!currentPrice || !quantityInput) return;
  
  const quantity = parseInt(quantityInput.value || 1);
  const basePrice = parseFloat(currentPrice.getAttribute('data-original-base-price') || currentPrice.getAttribute('data-solo-price') || 0);
  const shippingPriceCents = Math.round((parseFloat(localStorage.getItem('selectedDeliveryPrice')) || 0) * 100);
  // Zelfde afronding als app: totaal in één keer
  let productTotalCents = basePrice * quantity;
  if (typeof window.getStaffelDiscountedTotalCents === 'function') {
    productTotalCents = window.getStaffelDiscountedTotalCents(
      quantity,
      shippingPriceCents > 0 ? basePrice + shippingPriceCents : basePrice
    );
  }
  var totalPrice = productTotalCents;

  if (crossselling) {
    crossselling.forEach(function (p) {
      const checkbox = p.querySelector('input[type="checkbox"]');
      const crosssellingQuantityInput = p.querySelector('.quantity-input-crossselling');

      if (checkbox && checkbox.checked && crosssellingQuantityInput) {
        const crosssellingQuantity = parseInt(crosssellingQuantityInput.value || 1);
        const crosssellingPrice = parseFloat(
          p.querySelector('[data-product-price]').getAttribute('data-product-price')
        );
        totalPrice += crosssellingPrice * crosssellingQuantity;
      }
    });
  }

  // ADD SHIPPING – bij spoed al in totaal niet dubbel toevoegen
  const spoedAlreadyInBase = shippingPriceCents > 0 && typeof window.getStaffelDiscountedTotalCents === 'function';
  totalPrice = calculateTotalWithShipping(totalPrice, quantity, spoedAlreadyInBase);

  // Zelfde als updatePriceWithStock: excl.-totaal op het element zetten zodat vat-switcher na toggle klopt
  const totalPriceExcl = totalPrice;
  let displayTotal = totalPrice;
  if (sessionStorage.getItem('pricesIncludeVat') === 'true') {
    displayTotal *= 1.21;
  }

  const prettyPrice = Shopify.formatMoney(displayTotal, '{{amount_with_comma_separator}}');
  const prettyFullPrice = Shopify.formatMoney(displayTotal / 0.85, '{{amount_with_comma_separator}}');
  if (currentPrice) {
    currentPrice.setAttribute('data-excl-price', totalPriceExcl);
    currentPrice.setAttribute('data-price', displayTotal);
    currentPrice.innerHTML = `€${prettyPrice}`;

    if (document.getElementById('real-price')) {
      document.getElementById('real-price').innerHTML = `€${prettyFullPrice}`;
      document.getElementById('real-price').setAttribute('data-excl-price', displayTotal / 0.85);
      document.getElementById('real-price').setAttribute('data-real-price', displayTotal / 0.85);
    }
  }
}

function setupQuantityControls() {
  const quantityInput = document.querySelector('.quantity-input');
  const incrementButton = document.querySelector('.increment-button');
  const decrementButton = document.querySelector('.decrement-button');
  
  if (!quantityInput) return;

  quantityInput.addEventListener('change', () => {
    if (currentOptions) {
      updateCurrentOptions(currentOptions);
    }
  });

  if (incrementButton) {
    incrementButton.addEventListener('click', () => {
      const currentValue = parseInt(quantityInput.value);
      quantityInput.value = currentValue + 1;
      if (currentOptions) {
        updateCurrentOptions(currentOptions);
      }
    });
  }

  if (decrementButton) {
    decrementButton.addEventListener('click', () => {
      const currentValue = parseInt(quantityInput.value);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
        if (currentOptions) {
          updateCurrentOptions(currentOptions);
        }
      }
    });
  }
}

function updateBarcode(barcode) {
  const barcode_wrapper = document.querySelector('.barcode');
  if (barcode_wrapper) {
    barcode_wrapper.innerHTML = barcode;
  }
}

window.showCartNotification = showCartNotification;
window.hideCartNotification = hideCartNotification;
window.updateAllCartDropdowns = updateAllCartDropdowns;

// Add this in your global JS file
window.addEventListener('cartItemAdded', function(event) {
  console.log('cartItemAdded', event);
  const { cart, items } = event.detail;
  showCartNotification(cart, items);
  
  setTimeout(() => {
    hideCartNotification();
  }, 3000);
});